import React from "react";
import styled from "styled-components";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import ChatList from "./ChatList";
// import firebase from "firebase";
interface Props {
  listBookings: IPaymentTracking[];
  onChangeBooking: (booking: IPaymentTracking) => void;
}

export const ContainerCard = styled.div`
  flex: 1;
  height: calc(100vh - 4rem);
  position: relative;
  margin-left: 0;
  background: #ffffff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.01);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  max-width: 80px;
  margin: 2rem;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ListCustomer = (props: Props) => {
  // const db = firebase.firestore().collection("chats");
  // const [bookingList] = React.useState<IPaymentTracking[]>(
  //   props.listBookings
  // );
  // const [chats, setChats] = React.useState<any[]>([]);

  // React.useEffect(() => {
  //   console.log("action setBookingList");

  //   setBookingList(props.listBookings);
  // }, [props.listBookings, chats]);

  // const addChat = React.useCallback(
  //   (chat: any) => {
  //     const aleadyChat = chats.find((c) => c.uid === chat.uid);
  //     if (aleadyChat) return;
  //     setChats([...chats, chat]);
  //   },
  //   [chats]
  // );

  // const modifiedChat = React.useCallback(
  //   (chat: any) => {
  //     const newChats = chats.map((c) => {
  //       if (c.uid === chat.uid) return chat;
  //       else return c;
  //     });
  //     setChats(newChats);
  //   },
  //   [chats]
  // );

  // React.useEffect(() => {
  //   const unsubscribe = db.onSnapshot((snap) => {
  //     snap.docChanges().forEach((change) => {
  //       if (change.type === "added") {
  //         // console.log("Added ", change.doc.data());
  //         addChat(change.doc.data());
  //       }
  //       if (change.type === "modified") {
  //         // console.log("Modified: ", change.doc.data());
  //         modifiedChat(change.doc.data());
  //       }
  //     });
  //   });
  //   //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
  //   return () => unsubscribe();
  // }, [db, addChat, modifiedChat]);

  const handleClickList = (bookingId: string) => {
    const booking = props.listBookings.find(
      (booking) => booking.bookingId === bookingId
    );
    if (booking) return props.onChangeBooking(booking);
  };
  return (
    <ContainerCard>
      {props.listBookings.map((item) => {
        return (
          <ChatList
            isRead={true}
            onClick={handleClickList}
            uid={item.uid}
            imageUrl={item.imageUrl}
            key={item.bookingId}
            bookingId={item.bookingId}
          />
        );
      })}
    </ContainerCard>
  );
};

export default ListCustomer;
